import type { SocialNetwork } from '#/types/SocialNetwork';

export function getSocialNetworkFromLink(
  link: string,
): SocialNetwork | undefined {
  try {
    const url = new URL(link);

    if (
      url.hostname.includes('youtube.com') ||
      url.hostname.includes('youtu.be')
    )
      return 'youtube';

    if (
      url.hostname.includes('facebook.com') ||
      url.hostname.includes('fb.com') ||
      url.hostname.includes('fb.me') ||
      url.hostname.includes('fb.watch')
    )
      return 'facebook';

    if (url.hostname.includes('instagram.com')) return 'instagram';

    if (url.hostname.includes('tiktok')) return 'tiktok';

    if (
      url.hostname === 'x.com' ||
      url.hostname === 't.co' ||
      url.hostname.includes('twitter.com')
    )
      return 'x';

    if (
      url.hostname.includes('linkedin.com') ||
      url.hostname.includes('lnkd.in')
    )
      return 'linkedin';

    if (url.hostname.includes('candid.org')) return 'candid';

    return undefined;
  } catch {
    // Invalid url
    return undefined;
  }
}

export function splitSocialAndNonSocialLinks(links: string[]) {
  const nonSocialLinks: string[] = [];
  const socialLinks: { link: string; socialNetwork: SocialNetwork }[] = [];

  links.forEach((link) => {
    const socialNetwork = getSocialNetworkFromLink(link);
    if (socialNetwork) socialLinks.push({ link, socialNetwork });
    else nonSocialLinks.push(link);
  });

  return { nonSocialLinks, socialLinks };
}
